import HTTP from "@/_helpers/http";
import { ACCGROUPS__API } from "@/_helpers/urls";
import { ACCGROUPS__MUTATIONS } from "../mutation-types";
import { ACCGROUPS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

function filterObject(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

// State
const state = {
  groups: [],
  usergroups: [],
  currencies: []
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [ACCGROUPS__MUTATIONS.ACCGROUPS](state, data) {
    state.groups = data;
  },
  [ACCGROUPS__MUTATIONS.USERACCGROUPS](state, data) {
    state.usergroups = data;
  },
  [ACCGROUPS__MUTATIONS.GETCURRENCIESGROUP](state, data) {
    state.currencies = data;
  },
};

// Actions
const actions = {
  async [ACCGROUPS__ACTIONS.GETCURRENCIESGROUP]({ commit }) {
    try {
      const url = `${ACCGROUPS__API.GETCURRENCIESGROUP}`;
      const response = await HTTP().get(url);
      commit(ACCGROUPS__MUTATIONS.GETCURRENCIESGROUP, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [ACCGROUPS__ACTIONS.ACCGROUPS]({ commit }) {
    try {
      const url = `${ACCGROUPS__API.ACCGROUPS}`;
      const response = await HTTP().get(url);
      commit(ACCGROUPS__MUTATIONS.ACCGROUPS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [ACCGROUPS__ACTIONS.USERACCGROUPS]({ commit }, id) {
    try {
      const url = `${ACCGROUPS__API.USERACCGROUPS}/${id}`;
      const response = await HTTP().get(url);
      commit(ACCGROUPS__MUTATIONS.USERACCGROUPS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [ACCGROUPS__ACTIONS.UPDATEUSERACCGROUPS]({ dispatch }, parameter) {
    try {
      const filteredParameter = filterObject(parameter);

      const url = `${ACCGROUPS__API.UPDATEUSERACCGROUPS}`;
      const response = await HTTP().patch(url, filteredParameter);

      if (response.status === 200) {
        toast.success("Updated Successfully");
      }

      await dispatch(
        ACCGROUPS__ACTIONS.USERACCGROUPS,
        filteredParameter.client_account_id,
      );
    } catch (error) {
      console.log(error);
    }
  },

  async [ACCGROUPS__ACTIONS.CREATEACCGROUPS]({ dispatch }, parameter) {
    try {
      const url = `${ACCGROUPS__API.CREATEACCGROUPS}`;
      const response = await HTTP().post(url, parameter);

      if (response.status === 200) {
        toast.success("Created Successfully");
      }

      await dispatch(ACCGROUPS__ACTIONS.ACCGROUPS);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  },

  async [ACCGROUPS__ACTIONS.UPDATEACCGROUPS]({ dispatch }, parameter) {
    try {
      const filteredParameter = filterObject(parameter);

      const url = `${ACCGROUPS__API.UPDATEACCGROUPS}`;
      const response = await HTTP().patch(url, filteredParameter);

      if (response.status === 200) {
        toast.success("Updated Successfully");
      }

      await dispatch(ACCGROUPS__ACTIONS.ACCGROUPS);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  },

  async [ACCGROUPS__ACTIONS.DELETEACCGROUPS]({ dispatch }, parameter) {
    try {
      const url = `${ACCGROUPS__API.DELETEACCGROUPS}/${parameter?.id}`;
      await HTTP().delete(url);
      toast.success("Deleted Successfully");
      await dispatch(ACCGROUPS__ACTIONS.ACCGROUPS);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
